import React from 'react';
import { useTranslation } from 'react-i18next';
import { isFieldVisible, getFieldAutoFill } from '@/utils/fieldConfig';
import replaceCustomInputWithSelect from './replaceCustomInputWithSelect';

const ConditionalInput = ({
  children,
  fieldName,
  refundModalType,
  customPaymentType,
  isCustomPaymentTypesEnabled = true,
}) => {
  const { i18n } = useTranslation();

  if (!isCustomPaymentTypesEnabled) {
    return children;
  }
  if (!isFieldVisible(fieldName, refundModalType, customPaymentType)) {
    return null;
  }
  const autoFill = getFieldAutoFill(fieldName, customPaymentType);
  if (autoFill?.type === 'options' && autoFill.options?.length) {
    return React.Children.map(children, (child) =>
      replaceCustomInputWithSelect(child, autoFill.options, i18n.language),
    );
  }
  return children;
};

export default ConditionalInput;
